<!-- 我的购物车 -->
<template>
	<div id="shopcart">
		<div class="container">
			<div class="cart-wrap" v-if="shopCartList.length > 0">
				<!-- 购物车抬头 -->
				<div class="cart-title-wrap">
					<span class="cart-title">{{ $t("common.Header.031511-3") }}</span>
					<span class="shop-btn" @click="goShopping">{{ $t("mine.shopcart.567120-7") }}</span>
				</div>

				<!-- 购物车列表 -->
				<div id="mainContent" class="cart-list">
					<!-- 有效购物车 -->
					<div v-for="(item, index) in validShoppingCartList" class="cart-item flex-row">
						<div class="cart-checkbox">
							<el-checkbox
								v-model="item.isChecked"
								@change="checked => selectCart(checked, item.cartId)"
								:disabled="item.isInvalid"
							></el-checkbox>
						</div>
						<div class="goods-box">
							<div class="relative-pos" style="width: 140px">
								<img
									class="goods-img"
									:src="$utils.set400Img(item.coverPic)"
									:data-goodsid="item.goodsId"
									@click="gotoGoodsDetail(item)"
								/>
								<img
									class="sold-out-img"
									src="../../assets/images/ico-soldout.svg"
									v-if="isShowOverStockTag && item.stock < 1"
								/>
								<div v-if="isShowStockOuts && item.stock > 0 && item.stock <= 5">
									<div class="warn-stock">{{ $t("mine.shopcart.567120-9") }}</div>
								</div>
							</div>
							<div class="cart-goods-info">
								<div class="cart-goods-name" v-if="showGoodsName" :title="item.goodsName">
									<span class="presale-style activity-label" v-if="item.actType == '1'">{{ $t("home.home.336045-3") }}</span>
									{{ item.goodsName }}
								</div>
								<div
									class="cart-spec-name label-content"
									v-if="item.labelNameList && item.labelNameList.length > 0"
								>
									<span class="act-label" v-for="gitem in item.labelNameList">
										{{ gitem }}
									</span>
								</div>
								<div
									class="cart-spec-name text-ellipsis_oneline"
									v-if="isShowGoodsNo"
									:title="item.goodsNo"
								>
									{{ item.goodsNo }}
								</div>
								<div class="cart-spec-name text-ellipsis">
									<span
										v-if="(item.isMulti == '0' && isShowSingleSpec) || item.isMulti != '0'"
										class="cart-spec-unit"
									>
										{{ item.specName }}
									</span>
									<span class="">{{ $t("mine.shopcart.567120-4", [item.unitName]) }}</span>
								</div>
								<div class="cart-spec-name text-ellipsis" v-if="!!item.validityDate">
									{{ item.validityDate }}
								</div>
								<div class="cart-spec-name text-ellipsis" v-if="isShowGoodsBrand && !!item.brandNameCn">
									{{ $t("trade.GoodsList.009719-2", [item.brandNameCn]) }}
								</div>
								<div class="cart-spec-name text-ellipsis" v-if="!!item.longWidthHeightText">
									{{ item.longWidthHeightLabel }}{{ item.longWidthHeightText }}
								</div>
								<div class="cart-spec-name text-ellipsis" v-if="!!item.weightText">
									{{ item.weightLabel }}{{ item.weightText }}
								</div>
								<div class="cart-spec-name text-ellipsis" v-if="!!item.volumeText">
									{{ item.volumeLabel }}{{ item.volumeText }}
								</div>
							</div>
						</div>
						<div class="cart-price">
							<span v-if="item.executionPrice > 0 || (item.executionPrice && item.score == 0)">
								{{ $currency.symbol }}{{ $utils.filterTrailingZeros(item.executionPrice) }}
							</span>
							<span v-show="item.executionPrice && item.score > 0">+</span>
							<span v-show="item.score > 0">{{ $t("home.designpage.709803-0", [item.score]) }}</span>
							<div
								class="price-detail"
								v-if="
									isOpenShowDetailPrice &&
									(item.referencePrice > (item.executionPrice || 99999999) ||
										item.referencePrice > item.executionPrice)
								"
							>
								{{ $currency.symbol }}{{ $utils.filterTrailingZeros(item.referencePrice) }}
							</div>
						</div>
						<div class="cart-count-input">
							<div
								class="cart-stock-text"
								style="white-space: pre"
								v-if="!!item.validityDate || !!item.stockDesc"
							>
								<div v-if="!!item.stockDesc">
									<span :class="item.stock > 0 ? '' : 'zero-stock'">{{ item.stockDesc }}</span>
								</div>
							</div>

							<input-number
								inputStyle="shopcart"
								:cartId="item.cartId"
								:disabled="item.isInvalid"
								:curval="item.goodsCount"
								:min="parseInt(item.minCount)"
								:max="item.canBuyCount || 999999"
								:unitRate="item.unitCountRate || 1"
								:specId="item.specId"
								:goodsId="item.goodsId"
								:step="item.stepCount"
								:isMultiSpecUnit="true"
								:decimalDigits="item.isOpenDecimalpurchase == 1 ? decimalDigits : 0"
								@change="countChange"
							></input-number>
						</div>
						<div class="cart-del-btn" @click="delCart(item)">
							<i class="el-icon-delete"></i>
						</div>
					</div>

					<!-- 失效购物车 -->
					<div class="invalid-shopping-cart-box" v-if="isHaveInvalidShoppingCart">
						<!-- 失效购物车title -->
						<div class="invalid-shopping-cart-title" ref="invalidShoppingCartBox">
							<div class="invalid-title-text">{{ $t("mine.shopcart.567120-19") }}</div>
							<div class="invalid-title-clear" @click="clearInvalidShopCart">{{ $t("mine.shopcart.567120-15") }}</div>
						</div>

						<div v-for="(item, index) in invalidShoppingCartList" class="cart-item flex-row">
							<div class="cart-checkbox">
								<el-checkbox
									v-model="item.isChecked"
									@change="checked => selectCart(checked, item.cartIndex)"
									:disabled="item.isInvalid"
								></el-checkbox>
							</div>
							<div class="goods-box">
								<div class="relative-pos" style="width: 140px">
									<img
										class="goods-img"
										:src="$utils.set400Img(item.coverPic)"
										:data-goodsid="item.goodsId"
										@click="gotoGoodsDetail(item)"
									/>
									<img
										class="sold-out-img"
										src="../../assets/images/ico-soldout.svg"
										v-if="isShowOverStockTag && item.stock < 1"
									/>
									<div v-if="isShowStockOuts && item.stock > 0 && item.stock <= 5">
										<div class="warn-stock">{{ $t("mine.shopcart.567120-9") }}</div>
									</div>
								</div>
								<div class="cart-goods-info">
									<div class="cart-goods-name" v-if="showGoodsName" :title="item.goodsName">
										<span class="presale-style activity-label" v-if="item.actType == '1'">
											{{ $t("home.home.336045-3") }}
										</span>
										{{ item.goodsName }}
									</div>
									<div class="cart-goods-name" v-else :title="item.goodsNo">
										{{ item.goodsNo }}
									</div>
									<div class="cart-spec-name label-content">
										<span class="act-label" v-for="gitem in item.labelNameList">
											{{ gitem }}
										</span>
									</div>
									<div class="cart-spec-name text-ellipsis">
										<span
											v-if="(item.isMulti == '0' && isShowSingleSpec) || item.isMulti != '0'"
											class="cart-spec-unit"
										>
											{{ item.specName }}
										</span>
										<span class="">{{ $t("mine.shopcart.567120-4", [item.unitName]) }}</span>
									</div>
									<div class="cart-spec-name text-ellipsis" v-if="!!item.validityDate">
										{{ item.validityDate }}
									</div>
									<div
										class="cart-spec-name text-ellipsis"
										v-if="isShowGoodsBrand && !!item.brandName"
									>
										{{ $t("trade.GoodsList.009719-2", [item.brandName]) }}
									</div>
									<div class="cart-spec-name text-ellipsis" v-if="!!item.longWidthHeightText">
										{{ item.longWidthHeightLabel }}{{ item.longWidthHeightText }}
									</div>
									<div class="cart-spec-name text-ellipsis" v-if="!!item.weightText">
										{{ item.weightLabel }}{{ item.weightText }}
									</div>
									<div class="cart-spec-name text-ellipsis" v-if="!!item.volumeText">
										{{ item.volumeLabel }}{{ item.volumeText }}
									</div>

									<div v-if="item.isInvalid">
										<div class="warn-blockup">{{ $t("mine.shopcart.567120-0", [item.invalidReason]) }}</div>
									</div>
								</div>
							</div>
							<div class="cart-price">
								<span v-if="item.executionPrice > 0 || (item.executionPrice && item.score == 0)">
									{{ $currency.symbol }}{{ $utils.filterTrailingZeros(item.executionPrice) }}
								</span>
								<span v-show="item.executionPrice && item.score > 0">+</span>
								<span v-show="item.score > 0">{{ $t("home.designpage.709803-0", [item.score]) }}</span>
								<div
									class="price-detail"
									v-if="
										isOpenShowDetailPrice &&
										(item.referencePrice > (item.executionPrice || 99999999) ||
											item.referencePrice > item.executionPrice)
									"
								>
									{{ $currency.symbol }}{{ $utils.filterTrailingZeros(item.referencePrice) }}
								</div>
							</div>
							<div class="cart-count-input">
								<div
									class="cart-stock-text"
									style="white-space: pre"
									v-if="!!item.validityDate || !!item.stockDesc"
								>
									<div v-if="!!item.stockDesc">
										<span :class="item.stock > 0 ? '' : 'zero-stock'">{{ item.stockDesc }}</span>
									</div>
								</div>

								<input-number
									inputStyle="shopcart"
									:cartId="item.cartId"
									:disabled="item.isDisableToChangeCount"
									:curval="item.goodsCount"
									:min="parseInt(item.minCount)"
									:max="item.canBuyCount || 999999"
									:step="item.stepCount"
									:unitRate="item.unitCountRate || 1"
									:specId="item.specId"
									:goodsId="item.goodsId"
									:isMultiSpecUnit="true"
									:decimalDigits="item.isOpenDecimalpurchase == 1 ? decimalDigits : 0"
									@change="countChange"
								></input-number>
							</div>
							<div class="cart-del-btn" @click="delCart(item)">
								<i class="el-icon-delete"></i>
							</div>
						</div>
					</div>
				</div>

				<!-- crm促销策略匹配结果 -->
				<crm-ploy-info
					class="crm-ploy-info"
					v-if="isMatchedCrmPloy"
					:matchResult="crmPloyMatchResult"
				></crm-ploy-info>

				<!-- 总计结算 -->
				<div class="cart-bottom-wrap flex-row">
					<div class="cart-checkbox cart-all-checkbox">
						<el-checkbox v-model="isSelectAll" @change="selectAllCart">{{ $t("mine.shopcart.567120-16") }}</el-checkbox>
					</div>
					<div class="del-all-btn" @click="delAllCart">
						<i class="el-icon-delete"></i>
						<span>{{ $t("common.action.clear") }}</span>
					</div>
					<div class="sum-data-wrap flex-row">
						<div class="sum-data" v-show="selectedShopcartCount > 0">
							{{ $t("mine.shopcart.567120-22", [selectedShopcartCount, totalCount]) }}
						</div>
						<div class="sum-data sum-data-money">
							<span>{{ $t("mine.shopcart.567120-6") }}</span>
							<span class="sum-data-money-txt">{{ $currency.symbol }}{{ totalMoney }}</span>
							<span v-show="totalScore > 0">{{ $t("goods.WholeSaleGoodsItem.833487-10", [totalScore]) }}</span>
						</div>
						<div
							class="sum-data"
							v-if="discountAmount > 0 && isOpenShowDecuctionPrice"
							style="margin-left: 40px"
						>
							<span>{{ $t("mine.shopcart.567120-25") }}</span>
							<span>{{ $currency.symbol }}{{ $utils.amountFixed(discountAmount, 2) }}</span>
						</div>
					</div>
					<el-button class="pay-btn" type="danger" @click="goPay">{{ $t("mine.shopcart.567120-11") }}</el-button>
				</div>
			</div>

			<!-- 空购物车 -->
			<div class="empty-cart-wrap flex-col flex-center" v-else>
				<img class="empty-cart-img" src="../../assets/images/empty-cart.png" />
				<div class="empty-cart-tips">{{ $t("mine.shopcart.567120-12") }}</div>
				<el-button class="empty-cart-btn" type="danger" @click="goShopping">{{ $t("mine.collectlist.653644-4") }}</el-button>
			</div>
		</div>
		<!-- 货品检测弹窗 开启0库存、且开启0库存提醒,将不足的商品反馈给客户-->
		<check-goods-dialog
			:isShowDialog.sync="isShowStockCheckModal"
			:goodsList="cannotOrderGoodsList"
			:isNoValidGoods="isNoStockAll"
			:isNeedTitle="true"
			:confirmText="$t('goods.goodsdetail.362050-40')"
			:cancelText="$t('mine.shopcart.567120-21')"
			modalStyle="shopcart"
			:noValidGoodsTip="OpenZeroStock_tipText"
			:hasValidGoodsTip="OpenZeroStock_tipText"
			@confirm="toBuy"
			:isCancelOfGoHome="false"
			@cancel="filterThenToBuy"
		></check-goods-dialog>

		<!-- 货品检测弹窗 没开启开启0库存下单 库存检测-->
		<check-goods-dialog
			:isNeedTitle="true"
			:isFromShopCart="true"
			:isShowDialog.sync="isShowCheckGoodsDialog"
			:goodsList="cannotOrderGoodsList"
			:isNoValidGoods="isNoStockAll"
			:noValidGoodsTip="$t('mine.shopcart.567120-1')"
			:confirmText="$t('trade.CheckGoodsDialog.208610-6')"
			:cancelText="$t('trade.CheckGoodsDialog.208610-1')"
			:isCancelOfGoHome="false"
			:hasValidGoodsTip="$t('api_utils.api_goods_shoppingcart.848763-0')"
			@confirm="filterThenToTradeConfirmOfOutStock"
			@cancel="cancelCheckModal"
		></check-goods-dialog>
		<!-- 活动货品检测弹窗 -->
		<check-goods-dialog
			:isNeedTitle="true"
			:isFromShopCart="true"
			:isShowDialog.sync="isShowActivityGoodsStockCheckModal"
			:goodsList="activityGoodsOverOrderList"
			:isNoValidGoods="isNoStockAll"
			:isActivityOverStock="true"
			:noValidGoodsTip="$t('mine.shopcart.567120-1')"
			:hasValidGoodsTip="$t('mine.shopcart.567120-24')"
			:confirmText="$t('mine.shopcart.567120-20')"
			:cancelText="$t('trade.CheckGoodsDialog.208610-1')"
			:isCancelOfGoHome="false"
			@confirm="filterThenToTradeConfirmOfOutStock"
			@cancel="cancelCheckModal"
		></check-goods-dialog>
		<!-- 多单位货品检测弹窗 -->
		<check-goods-dialog
			:isShowDialog.sync="isShowMultiUnitStockCheckModal"
			:goodsList="baseUnitOverOrderGoodsList"
			:isMultiUnitOverStock="true"
			:hasValidGoodsTip="$t('mine.shopcart.567120-8')"
			@confirm="multiUnitOverStockConfirm"
		></check-goods-dialog>
		<!-- 商品级限购数量检测 -->
		<check-goods-dialog
			:isShowDialog.sync="isShowGoodsBoughtLimitModal"
			:goodsList="goodsBoughtLimitList"
			:isNoValidGoods="false"
			:hasValidGoodsTip="$t('mine.shopcart.567120-23')"
			:confirmText="$t('trade.tradeconfirm.047740-14')"
			:isShowCancelBtn="false"
			@confirm="goodsBoughtLimitConfirm"
		></check-goods-dialog>
	</div>
</template>

<script>
	import vHeader from "../../components/common/Header.vue";
	import goodsUtils from "../../utils/api-utils/api-goods.js";
	import commonUtils from "../../utils/common-utlis.js";
	import checkGoodsDialog from "../../components/trade/CheckGoodsDialog.vue";
	import crmPloyInfo from "../../components/goods/CrmPloyInfo.vue";
	import inputNumber from "../../components/goods/InputNumber.vue";
	import {
		getShoppingCartList,
		updateShoppingCartCount,
		checkGoodsCount,
	} from "../../utils/api-utils/api-goods-shoppingcart.js";
	import { getParam } from "../../utils/api-utils/api-params.js";
	import { matchCrmPromotionPloy } from "../../utils/api-utils/api-goods-price.js";
	export default {
		name: "shopcart",
		components: {
			"v-header": vHeader,
			"check-goods-dialog": checkGoodsDialog,
			"crm-ploy-info": crmPloyInfo,
			"input-number": inputNumber,
		},
		data() {
			return {
				channelId: "", // 渠道Id
				checked: false,
				shopCartList: [], //购物车列表
				orginShopCartList: [], // 原始购物车
				isSelectAll: false, //是否全选
				totalMoney: 0.0, //选中商品总额
				totalScore: 0, //选中商品总积分
				// cartType: 2, //购物车来源 -1再来一单进入 2为PC端
				cartType: 0, //购物车来源 -1再来一单进入 2为PC端
				min: 1,
				max: 50,
				isOpenZeroStockBuy: false, //0库存下单
				isShowSingleSpec: true,
				isOpenIndistinctStock: false, // 模糊库存
				isOpenShowDetailPrice: false, //展示零售价
				isShowGoodsStock: false, //展示库存
				showGoodsName: !["795330"].includes(localStorage.getItem("JackyunUserName")),
				OpenZeroStock_tipText: "", // 0库存提示
				OpenZeroStock_isOpenRemind: false, // 是否开启0库存提醒
				cannotOrderGoodsList: [], // 不能下单商品列表
				isNoStockAll: false, // 全部库存不足
				isShowStockCheckModal: false, //展示库存校验弹窗
				isShowMultiUnitStockCheckModal: false, //展示多单位库存校验弹窗
				baseUnitOverOrderGoodsList: [], //展示多单位库存不足货品
				goodsBoughtLimitList: [], // 商品级限购量 限制货品
				isMatchedCrmPloy: false, // 是否匹配到CRM策略
				crmPloyMatchResult: {}, // crm促销策略匹配结果
				crmPloyDeductionAmount: 0, // crm促销策略抵扣金额
				premiumMembershipDiscountAmount: 0, // 付费会员优惠金额
				isMounted: false, // 是否渲染完成
				isShowCheckGoodsDialog: false, // 是否展示弹窗
				isShowActivityGoodsStockCheckModal: false, // 是否展示弹窗
				activityGoodsOverOrderList: [], // 活动商品超卖列表
				selectedShopcartCount: 0, // 购物车勾选数量 规格级
				isShowGoodsBoughtLimitModal: false, // 是否展示商品级限购弹窗
				decimalDigits: 0, // 小数位数
			};
		},
		created: async function () {
			// 加载页面参数
			await this._loadParams();

			//加载购物车列表
			await this.getShopCartList();
		},
		mounted() {
			let customerId = localStorage.getItem("pc_customerId");
			if (!customerId) {
				this.$eventBus.$emit("showLoginDialog", true, false); //显示登录弹窗,不可关闭
			}
		},
		destroyed() {
			this.$eventBus.$emit("showLoginDialog", false, true); //隐藏登录弹窗,可关闭
		},
		computed: {
			//（使用计算属性统计计算数量总额，无需监听数量输入框，删除按钮等）
			//当前选中的购物车列表
			checkedCartList() {
				let checkedList = [];
				if (this.isSelectAll) {
					checkedList = this.shopCartList.filter(t => !t.isInvalid);
				} else {
					checkedList = this.shopCartList.filter(t => t.isChecked);
				}

				return checkedList;
			},
			//当前选中的商品总数
			totalCount() {
				let tCount = 0,
					tMoney = 0,
					tScore = 0,
					tRenference = 0;
				for (let i = 0; i < this.checkedCartList.length; i++) {
					let cart = this.checkedCartList[i];
					if (cart.isInvalid) continue;
					let count = parseFloat(cart.goodsCount);
					tCount += count;
					tMoney += parseFloat(parseFloat(cart.executionPrice) * count);
					tScore += parseFloat((cart.score || 0) * count);
					tRenference += parseFloat(
						Math.max(cart.referencePrice, cart.executionPrice) * count
					);
				}
			this.totalMoney = tMoney.toFixed(2);
			this.totalScore = commonUtils.roundToDecimal(tScore, this.decimalDigits); // 保留小数
			this.premiumMembershipDiscountAmount = tRenference - tMoney;
				this.selectedShopcartCount = commonUtils.mergeAndSum(this.checkedCartList, [
					"goodsId",
					"specId",
				]).length;
				return tCount;
			},
			//当前所有购物车Id,清空购物车时用到
			allCartIds() {
				var ids = [];
				for (let i = 0; i < this.shopCartList.length; i++) {
					ids.push(this.shopCartList[i].cartId);
				}
				return ids;
			},
			/**
			 * 优惠金额
			 */
			discountAmount() {
				return commonUtils.floatKeepDigit(this.crmPloyDeductionAmount + this.premiumMembershipDiscountAmount);
			},
		},
		watch: {
			/**
			 * 监听促销策略匹配结果
			 * @param {Object} newValue
			 * @param {Object} oldValue
			 */
			crmPloyMatchResult(newValue, oldValue) {
				// 计算容器高度
				let paddingBottom = 0;
				if (newValue.promotionResult && newValue.promotionResult.length > 0) {
					let resultLength = newValue.promotionResult.length;
					resultLength = resultLength > 3 ? 3 : resultLength;
					paddingBottom = resultLength * 24 + 20;
				}
				document.getElementById("mainContent") &&
					(document.getElementById("mainContent").style.paddingBottom = paddingBottom + "px");
			},
		},
		methods: {
			/**
			 * 加载页面参数
			 */
			async _loadParams() {
				//获取页面传递的参数
				let params = this.$route.params;
				if (params && params.cartFrom == "再来一单") {
					this.cartType = "-1";
				}

				// 获取后台配置参数
				let paramList = await getParam(
					"OpenZeroStock_isOpenRemind,OpenZeroStock_tipText,bindSaleChannelId,isOpenZeroStockBuy,isShowSingleSpec,isOpenIndistinctStock,isShowGoodsStock,isOpenShowDetailPrice,isShowStockOuts,isShowOverStockTag,labelsInExtraPage,pcHomePageType,isShowGoodsNo,isOpenShowDecuctionPrice,isShowGoodsBrand,decimalDigits"
				);
				// 默认渠道
				this.channelId = paramList.bindSaleChannelId || "";
				this.decimalDigits = parseInt(paramList.decimalDigits) || 0;
				// 0库存下单
				this.isOpenZeroStockBuy = paramList.isOpenZeroStockBuy == "1";
				// 0库存下单提醒
				this.OpenZeroStock_isOpenRemind = paramList.OpenZeroStock_isOpenRemind == "1";
				this.OpenZeroStock_tipText = paramList.OpenZeroStock_tipText || "";
				// 库存展示
				this.isShowSingleSpec = paramList.isShowSingleSpec != "0";
				// 模糊库存展示
				this.isOpenIndistinctStock = paramList.isOpenIndistinctStock == "1";
				// 精确库存
				this.isShowGoodsStock = paramList.isShowGoodsStock == "1";
				// 零售价展示
				this.isOpenShowDetailPrice = paramList.isOpenShowDetailPrice == "1";
				// 是否展示缺货库存
				this.isShowStockOuts = paramList.isShowStockOuts != "0";
				// 是否展示缺货标签
				this.isShowOverStockTag = paramList.isShowOverStockTag != "0";
				// 商品标签展示数据
				this.labelsInExtraPage = paramList.labelsInExtraPage || "";
				// 首页模式
				this.pcHomePageType = paramList.pcHomePageType || "normal";
				// 是否展示商品编号
				this.isShowGoodsNo = paramList.isShowGoodsNo == "1";
				this.isOpenShowDecuctionPrice = paramList.isOpenShowDecuctionPrice == "1";
				this.isShowGoodsBrand = paramList.isShowGoodsBrand == "1";
			},

			//加载购物车列表
			async getShopCartList() {
				//展示加载遮罩层
				let loadingLayer = this.$loading({
					lock: true,
					background: "rgba(255, 255, 255, 0.2)",
				});

				// 渲染购物车
				let tempShopCartList = await getShoppingCartList({
					cartType: this.cartType,
					isRefresh: true,
					isAllowOutOfStock: this.isOpenZeroStockBuy,
					isGetValidityDate: this.isShowGoodsValidityDate,
					isGetGoodsLimitDataList: true,
				});
				tempShopCartList.forEach((cart, index) => {
					// 处理需要展示的标签
					let labelListInExtraPage = this.labelsInExtraPage.split(",");
					let labelNameList = (cart.labels || "")
						.split(",")
						.filter(item => item && labelListInExtraPage.includes(item));

					// 补充标签数据
					let tempMarketingLabelName =
						cart.marketingInfoList && cart.marketingInfoList[0] && cart.marketingInfoList[0].labelName;
					tempMarketingLabelName && labelNameList.unshift(tempMarketingLabelName);
					cart.labelNameList = labelNameList;

					// 补充索引
					cart.cartIndex = index;

					// 补充是否选择
					cart.isChecked = false;

					//设置长宽高和重量的展示文本
					commonUtils.getAndSetSkuInfoText(cart, this, cart.unitInfoList, cart.unitName);
				});

				this.shopCartList = tempShopCartList;

				//关闭加载遮罩层
				loadingLayer.close();

				// 处理有效购物车数据 和 失效购物车数据
				this.setShowShoppingCartList();
			},

			/**
			 * 处理有效购物车数据 和 失效购物车数据
			 */
			setShowShoppingCartList() {
				// 有效购物车列表
				this.validShoppingCartList = this.shopCartList.filter(item => !item.isInvalid);

				// 失效购物车列表
				this.invalidShoppingCartList = this.shopCartList.filter(item => item.isInvalid);

				// 是否存在失效商品
				this.isHaveInvalidShoppingCart = this.invalidShoppingCartList.length > 0;
			},

			//继续购物
			goShopping() {
				// 开启批发模式则需要跳转批发下单
				this.$router.push({
					name: this.pcHomePageType == "quickshopping" ? "quickshopping" : "goodslist",
					params: {},
				});
			},

			//选中单个商品
			async selectCart(checked, cartId) {
				// let cartItem = this.shopCartList.find(item => cartId == item.cartId);

				// cartItem.isChecked = checked

				this.isSelectAll = checked && this.checkedCartList.length == this.shopCartList.length;

				// 匹配crm促销策略
				this.__matchCrmPromotionPloy();
			},
			//全选
			selectAllCart(checked) {
				this.shopCartList
					.filter(item => !item.isInvalid)
					.forEach(item => {
						item.isChecked = checked;
					});

				this.isSelectAll = checked;

				// 匹配crm促销策略
				this.__matchCrmPromotionPloy();
			},

			//删除单个商品
			delCart(cartItem) {
				let cartId = cartItem.cartId;

				this.$confirm(this.$t("mine.shopcart.567120-17"), this.$t("common.Header.031511-10")).then(async () => {
					//删除
					let successJudge = await goodsUtils.deleteShoppingCart([cartId]);

					if (!successJudge) {
						return this.$message.error(this.$t("trade.AddressList.276662-4"));
					}

					this.shopCartList = this.shopCartList.filter(item => item.cartId != cartId);
					this.$message({
						type: "success",
						message: this.$t("common.prompt.deleteSuccess"),
					});
					this.$eventBus.$emit("updateHeaderShopCartCount"); //修改购物车总数

					// 匹配crm促销策略
					this.__matchCrmPromotionPloy();

					// 处理有效购物车数据 和 失效购物车数据
					this.setShowShoppingCartListAfterDelete([cartId]);
				});
			},
			//清空购物车
			delAllCart() {
				this.$confirm(this.$t("mine.shopcart.567120-17"), this.$t("common.Header.031511-10"), {
					confirmButtonText: this.$t("common.action.confirm"),
					cancelButtonText: this.$t("common.action.cancel"),
				}).then(async () => {
					//删除
					let successJudge = await goodsUtils.deleteShoppingCart(this.allCartIds);

					if (!successJudge) {
						return this.$message.error(this.$t("mine.shopcart.567120-14"));
					}

					this.shopCartList = [];
					this.isSelectAll = false;
					this.$message({
						type: "success",
						message: this.$t("mine.shopcart.567120-13"),
					});
					this.$eventBus.$emit("updateHeaderShopCartCount"); //修改购物车总数

					// 匹配crm促销策略
					this.__matchCrmPromotionPloy();
				});
			},

			/**
			 * 通过cartId 删除购物车
			 */
			async setShowShoppingCartListAfterDelete(cartIdList, isNeedRefresh = false) {
				// 有效购物车列表
				this.validShoppingCartList = this.validShoppingCartList.filter(
					item => !cartIdList.includes(item.cartId)
				);

				// 失效购物车列表
				this.invalidShoppingCartList = this.invalidShoppingCartList.filter(
					item => !cartIdList.includes(item.cartId)
				);

				// 是否存在失效商品
				this.isHaveInvalidShoppingCart = this.invalidShoppingCartList.length > 0;

				isNeedRefresh && this.setShowShoppingCartList();
			},

			multiUnitOverStockConfirm() {
				this.isShowMultiUnitStockCheckModal = false;
			},

			//立即结算
			async goPay() {
				let that = this;
				//数据验证
				if (this.checkedCartList.length == 0) {
					this.$message.closeAll();
					this.$message.warning(this.$t("mine.shopcart.567120-5"));
					return false;
				}

				// 展示加载遮罩层
				let loadingLayer = this.$loading({
					lock: true,
					text: this.$t("mine.shopcart.567120-10"),
					background: "rgba(255, 255, 255, 0.2)",
				});

				// 关闭弹窗
				loadingLayer.close();

				// 库存校验
				if (!(await this._checkOrderGoodsStock())) {
					return this.$message.error(this.$t("api_utils.api_goods_shoppingcart.848763-0"));
				}

				// 商品级限购量校验
				if (!(await this._checkGoodsBoughtLimit())) {
					return;
				}

				let filteredCartList = this.checkedCartList;

				// 对0元商品进行校验
				for (var i = 0; i < filteredCartList.length; i++) {
					if (parseFloat(filteredCartList[i].executionPrice) == 0) {
						return this.$message.error(this.$t("mine.shopcart.567120-3"));
					}
					break;
				}

				if (
					this.isOpenZeroStockBuy &&
					this.OpenZeroStock_isOpenRemind &&
					!this._ZeroStockCheckRemind(filteredCartList)
				) {
					return;
				}

				// 检测库存过滤后是否还有货品，没有则提示异常信息
				if (filteredCartList.length <= 0) {
					return this.$message.error(this.$t("mine.shopcart.567120-26"));
				}

				this.goTradeConfirm(filteredCartList);
			},
			toBuy(filteredCartList) {
				this.isShowDialog = false;
				if (!filteredCartList) {
					filteredCartList = this.checkedCartList;
				}
				this.goTradeConfirm(filteredCartList);
			},

			/**
			 * 过滤后去下单 没开启0库存下单
			 */
			filterThenToTradeConfirmOfOutStock() {
				// 获取可下单货品列表
				let canOrderGoodsList = this.canOrderGoodsList;
				// 获取当前购物车列表
				let filteredCartList = this.checkedCartList;

				let promiseList = [];
				// 修改库存不足的商品选购量
				canOrderGoodsList.forEach(goods => {
					// 获取当前购物车对应的
					let cartInfo = filteredCartList.find(
						t => t.goodsId == goods.goodsId && t.specId == goods.specId && t.unitName == goods.unitName
					);

					// 赋值cartId
					goods.cartId = cartInfo.cartId;

					promiseList.push(updateShoppingCartCount(cartInfo.cartId, goods.goodsCount));
				});

				// 循环修改购物车数量
				Promise.all(promiseList).then(() => {
					this.toBuy(filteredCartList);
				});
			},

			/**
			 * 过滤后去下单 开启0库存、且开启0库存提醒
			 */
			filterThenToBuy() {
				// 去除库存为0并且小于最小起购量的商品
				let filteredCartList = this.checkedCartList.filter(t => t.stock > 0 && t.stock >= t.minCount);

				let promiseList = [];
				// 修改库存不足的商品选购量
				filteredCartList.forEach(t => {
					if (t.stock > 0 && t.stock < t.goodsCount) {
						promiseList.push(updateShoppingCartCount(t.cartId, t.stock));
					}
				});

				// 循环修改购物车数量
				Promise.all(promiseList).then(() => {
					this.toBuy(filteredCartList);
				});
			},

			/**
			 * 零库存下单时候进行提醒
			 * @param {Object} filteredCartList
			 */
			_ZeroStockCheckRemind(filteredCartList) {
				try {
					// 判断是否大于库存
					let hasStockButNoEnoughCount = 0;
					let cannotOrderGoodsList = filteredCartList
						.filter(t => t.stock < parseFloat(t.goodsCount))
						.map(t => {
							if (t.stock > 0) {
								hasStockButNoEnoughCount++;
							}
							return {
								imgUrl: t.coverPic,
								goodsName: t.goodsName,
								specName: t.specName,
								unitName: t.unitName,
								goodsCount: t.goodsCount - (t.stock > 0 ? t.stock : 0),
								stock: t.stock,
							};
						});
					// 渲染前端页面
					if (cannotOrderGoodsList.length > 0) {
						this.isShowStockCheckModal = true;
						this.cannotOrderGoodsList = cannotOrderGoodsList;

						return false;
					}
					return true;
				} catch (e) {
					return true;
				}
			},

			goTradeConfirm(filteredCartList) {
				// 跳转到下单页
				let cartIds = filteredCartList.map(item => item.cartId).join(",");

				// 跳转到下单页
				this.$router.push({
					name: "tradeconfirm",
					params: {
						trade_from: "PC购物车",
						cartIds,
					},
				});
			},

			/**
			 * 过滤货品数据，将库存为0的商品去除，以及修改选购量
			 */
			_filterGoodsList(checkedCartList) {
				// 去除库存为0的商品
				checkedCartList = checkedCartList.filter(t => t.stock > 0 && !t.isInvalid);
				// 修改库存不足的商品选购量
				checkedCartList.forEach(t => {
					if (t.stock < t.goodsCount) {
						t.goodsCount = t.stock;
					}
				});

				return checkedCartList;
			},

			/**
			 * 跳转商品详情
			 * @param {Object} good
			 */
			gotoGoodsDetail(cart) {
				let goodsId = cart.packageGoodsId || cart.goodsId;

				// 限时抢购商品
				if (cart.actType == 1) {
					return this.$router.push({
						name: "timedsalegoodsdetail",
						query: {
							saleId: cart.actId,
							goodsId: cart.goodsId,
						},
					});
				}

				let encode = window.btoa(window.encodeURIComponent(goodsId));
				this.$router.push({
					name: "goodsdetail",
					query: {
						id: encode,
					},
				});
			},

			/**
			 * 计算营销活动价格
			 */
			calcMarketingPrice() {
				// 遍历需要补充的sku列表，进行价格补充
				this.shopCartList
					.filter(item => item.actId == "0")
					.forEach(cart => {
						// 获取匹配的营销活动信息
						let marketingInfo = cart.marketingInfoList.find(
							t => cart.goodsCount >= t.limitCount && cart.goodsCount <= t.upperLimitCount
						);

						// 满足数量要求，则执行营销活动价
						if (marketingInfo) {
							cart.executionPrice = marketingInfo.favorablePrice;
							cart.marketingInfo = marketingInfo;
						} else {
							cart.executionPrice = cart.memberPrice;
							cart.marketingInfo = {};
						}
					});
			},

			/**
			 * 匹配CRM促销策略
			 */
			__matchCrmPromotionPloy: commonUtils.debounce(
				async function () {
					// 去除无效商品
					let effectiveShoppingCartList = this.checkedCartList;
					if (!(effectiveShoppingCartList.length > 0)) {
						// 重置crm促销策略匹配结果
						this.__resetCrmPloyMatchResult();
						return;
					}

					// 匹配CRM促销策略
					let crmPloyMatchResult = await matchCrmPromotionPloy(effectiveShoppingCartList);
					if (!(crmPloyMatchResult.promotionRemindDtoList.length > 0)) {
						// 重置crm促销策略匹配结果
						this.__resetCrmPloyMatchResult();
						return;
					}

					// 渲染数据
					this.isMatchedCrmPloy = false; // 是否匹配到促销策略
					this.isMatchedCrmPloy = true; // 是否匹配到促销策略
					this.crmPloyMatchResult = crmPloyMatchResult; // 促销策略匹配结果
					this.crmPloyDeductionAmount = crmPloyMatchResult.discount; // crm促销策略抵扣金额
					this.totalMoney = commonUtils.floatKeepDigit(
						commonUtils.roundToDecimal(this.totalMoney) - crmPloyMatchResult.discount
					); // 渲染订单合计
				},
				300,
				false
			),

			/**
			 * 重置crm促销策略匹配结果
			 */
			__resetCrmPloyMatchResult() {
				this.isMatchedCrmPloy = false; // 是否匹配到促销策略
				this.crmPloyMatchResult = []; // 促销策略匹配结果
				this.crmPloyDeductionAmount = 0; // crm促销策略抵扣金额
			},

			/**
			 * 滚动到失效商品列表
			 */
			scrollToInvalidShoppingCartBox() {
				commonUtils.scrollToElement(this, "invalidShoppingCartBox");
			},

			/**
			 * 清空失效商品
			 */
			clearInvalidShopCart() {
				// 检测是否存在失效商品
				if (!(this.invalidShoppingCartList && this.invalidShoppingCartList.length > 0)) {
					this.$message.error(this.$t("mine.shopcart.567120-27"));
					return;
				}

				this.$confirm(this.$t("mine.shopcart.567120-17"), this.$t("common.Header.031511-10")).then(async () => {
					let deleteCartIdList = this.invalidShoppingCartList
						.filter(item => item.isInvalid)
						.map(item => item.cartId);

					//删除
					let successJudge = await goodsUtils.deleteShoppingCart(deleteCartIdList);

					if (!successJudge) {
						return this.$message.error(this.$t("mine.shopcart.567120-14"));
					}

					this.isHaveInvalidShoppingCart = false;
					this.shopCartList = this.shopCartList.filter(item => !deleteCartIdList.includes(item.cartId));
					this.$message({
						type: "success",
						message: this.$t("mine.shopcart.567120-13"),
					});
					this.$eventBus.$emit("updateHeaderShopCartCount"); //修改购物车总数

					// 匹配crm促销策略
					this.__matchCrmPromotionPloy();

					// 处理有效购物车数据 和 失效购物车数据
					this.setShowShoppingCartListAfterDelete(deleteCartIdList, true);
				});
			},

			/**
			 * 数量变化 数量框回调
			 */
			countChange: commonUtils.debounce(
				async function (newVal, cartId) {
					let cartItem = this.shopCartList.find(item => cartId == item.cartId);

					// 更新购物车数量
					if (await updateShoppingCartCount(cartItem.cartId, newVal)) {
						cartItem.goodsCount = newVal;

						// 计算选中的促销数据
						this.calcMarketingPrice();
						this.$eventBus.$emit("updateHeaderShopCartCount"); //修改购物车总数
					}

					// 购物车商品是否失效处理
					this.__handleCartValid(cartItem);

					// 匹配crm促销策略
					this.__matchCrmPromotionPloy();
				},
				300,
				false
			),

			/**
			 * 购物车商品是否失效处理
			 */
			__handleCartValid(cartItem) {
				// 不为失效商品 直接返回
				if (!cartItem.isInvalid) {
					return;
				}

				checkGoodsCount([cartItem], this.isOpenZeroStockBuy);
			},

			/**
			 * 检测下单货品库存
			 */
			async _checkOrderGoodsStock() {
				// 检测普通库存
				let baseStockCheck = await this._checkOrderGoodsBaseStock();
				// 检测活动库存
				let activityStockCheck = baseStockCheck && (await this._checkOrderGoodsActivityStock());

				return baseStockCheck && activityStockCheck;
			},

			/**
			 * 检测下单货品erp库存
			 */
			async _checkOrderGoodsBaseStock() {
				// 生成检测数据
				let preCheckGoodsList = this.checkedCartList.map(t => {
					return {
						goodsId: t.goodsId,
						specId: t.specId,
						unitName: t.unitName || "",
						goodsCount: t.goodsCount,
						activityType: t.actType,
						actId: t.actId,
					};
				});

				// 检测货品库存，结果包含可购和不可购两个列表
				let res = await goodsUtils.checkGoodsErpStock(preCheckGoodsList);

				if (res.baseUnitOverOrderGoodsList.length == 0) {
					return true;
				}

				// 超卖情况下，下单商品包含多单位
				if (this._checkCartHasMultiUnitOverOrder(res)) {
					this.isShowMultiUnitStockCheckModal = true;
					this.baseUnitOverOrderGoodsList = res.baseUnitOverOrderGoodsList;
				} else {
					// 数据渲染
					this.canOrderGoodsList = res.canOrderGoodsList; // 限购商品列表
					this.cannotOrderGoodsList = res.baseUnitOverOrderGoodsList; // 剩余可购规格Id
					this.isNoStockAll = res.canOrderGoodsList.length <= 0; // 是否无可购商品
					this.isShowCheckGoodsDialog = true; // 是否展示库存检测弹窗，存在库存不足的货品就展示
				}
				return false;
			},

			/**
			 * 检测超卖情况下下单货品是否包含多单位
			 */
			_checkCartHasMultiUnitOverOrder: function (checkStockResult) {
				// 超卖商品的SpecId数组
				let resultSpecIdList = checkStockResult.baseUnitOverOrderGoodsList.map(item => item.specId);
				let cartUnitOverOrderListLength = this.checkedCartList.filter(t =>
					resultSpecIdList.includes(t.specId)
				).length;
				return cartUnitOverOrderListLength > resultSpecIdList.length;
			},

			/**
			 * 检测下单货品活动库存
			 */
			async _checkOrderGoodsActivityStock() {
				try {
					let that = this;

					// 避免原数组被更改
					let checkedCartList = JSON.parse(JSON.stringify(this.checkedCartList));

					// 生成检测数据
					let actGoodsList = checkedCartList
						.filter(item => item.actId)
						.map(t => {
							return {
								goodsId: t.goodsId,
								specId: t.specId,
								unitName: t.unitName || "",
								goodsCount: t.goodsCount,
								activityType: t.actType,
								actId: t.actId,
							};
						});

					// 如果不存在活动商品 直接返回
					if (actGoodsList.length == 0) {
						return true;
					}

					// 获取 活动商品 最大可购数
					let actGoodsMaxCountInfoList = await goodsUtils.checkGoodsActivityStock(actGoodsList);

					actGoodsMaxCountInfoList.forEach(item => {
						let tempGoods = checkedCartList.find(
							cartItem =>
								cartItem.goodsId == item.goodsId &&
								cartItem.specId == item.specId &&
								cartItem.unitName == item.unitName &&
								cartItem.actType == item.activityType &&
								cartItem.actId == item.actId
						);
						// 超卖库存赋值
						item.overStock = tempGoods.goodsCount - item.buyCountMax;
						// 超卖弹窗需要数据补充
						item.goodsName = tempGoods.goodsName;
						item.coverPic = tempGoods.coverPic;
					});

					// 超卖活动商品
					let overOrderGoodsList = actGoodsMaxCountInfoList.filter(item => item.overStock > 0);

					// 如果不存在超卖活动商品 直接返回
					if (overOrderGoodsList.length == 0) {
						return true;
					}

					let canOrderGoodsList = checkedCartList.map(cartItem => {
						let overOrderGoods = overOrderGoodsList.find(
							item =>
								cartItem.goodsId == item.goodsId &&
								cartItem.specId == item.specId &&
								cartItem.unitName == item.unitName &&
								cartItem.actType == item.activityType &&
								cartItem.actId == item.actId
						);
						cartItem.goodsCount = overOrderGoods ? overOrderGoods.buyCountMax : cartItem.goodsCount;
						return cartItem;
					});

					// 过滤数量为0的可购购物车商品
					canOrderGoodsList = canOrderGoodsList.filter(item => item.goodsCount > 0);

					// 数据渲染
					this.canOrderGoodsList = canOrderGoodsList; // 限购商品列表
					this.activityGoodsOverOrderList = overOrderGoodsList; // 剩余可购规格Id
					this.isNoStockAll =
						overOrderGoodsList.length == checkedCartList.length && canOrderGoodsList.length == 0; // 是否无可购商品
					// this.isNoStockAll = false
					this.isShowActivityGoodsStockCheckModal = true; // 是否展示库存检测弹窗，存在库存不足的货品就展示

					return false;
				} catch (e) {
					return true;
				}
			},

			/**
			 * 关闭库存检测弹窗
			 */
			async cancelCheckModal() {
				// 重置数据
				this.isShowCheckGoodsDialog = false;
				this.isShowActivityGoodsStockCheckModal = false;

				// 刷新购物车
				await this.getShopCartList();

				this.scrollToInvalidShoppingCartBox();
			},

			/**
			 * 商品级限购数量检测
			 */
			async _checkGoodsBoughtLimit() {
				try {
					// 生成检测数据 套餐商品不校验
					let preCheckGoodsList = this.checkedCartList
						.filter(item => item.goodsType != 1)
						.map(t => {
							return {
								goodsId: t.goodsId,
								unitName: t.unitName || "",
								goodsCount: t.goodsCount,
							};
						});

					// 不存在有效商品直接返回
					if (!(preCheckGoodsList && preCheckGoodsList.length > 0)) {
						return true;
					}

					// 不满足限购数量的商品
					let goodsBoughtLimitList = await goodsUtils.checkGoodsBoughtLimit(preCheckGoodsList);

					if (goodsBoughtLimitList.length == 0) {
						return true;
					}

					// 组装limitText
					goodsBoughtLimitList.forEach(item => {
						item.limitText = this.$t("mine.shopcart.567120-2", [item.customerLimitCount]);
						item.overStock = item.overCount;
						item.unitName = item.baseUnitName;
					});

					// 数据渲染
					this.goodsBoughtLimitList = goodsBoughtLimitList; // 限制商品
					this.isShowGoodsBoughtLimitModal = true; // 是否展示商品级限购检测弹窗
					return false;
				} catch (e) {
					return true;
				}
			},

			/**
			 * 取消商品级限购检测
			 */
			goodsBoughtLimitConfirm() {
				this.isShowGoodsBoughtLimitModal = false; // 是否展示商品级限购检测弹窗
			},
		},
	};
</script>

<style scoped="scoped">
	.empty-cart-wrap {
		margin: 20px auto;
		max-width: calc(100vw - 60px);
		background-color: #fff;
		position: relative;
		height: calc(100vh - 110px);
	}

	.empty-cart-img {
		width: 151px;
		height: 128px;
	}

	.empty-cart-tips {
		color: #ccc;
		font-size: 18px;
		line-height: 120px;
	}

	.empty-cart-btn {
		width: 200px;
		height: 70px;
		font-size: 20px;
	}

	.cart-wrap {
		margin: 20px auto;
		max-width: calc(100vw - 60px);
		background-color: #fff;
		padding: 30px 0 70px;
		position: relative;
	}

	.cart-title-wrap {
		padding: 0 50px;
		height: 50px;
		line-height: 40px;
		border-bottom: solid 1px #eee;
		display: flex;
		justify-content: space-between;
	}

	.cart-title {
		font-size: 18px;
		font-weight: bold;
		letter-spacing: 2px;
	}

	.shop-btn {
		color: #f56c6b;
		font-size: 18px;
		cursor: pointer;
	}

	.cart-list {
		height: calc(100vh - 250px);
		overflow-y: auto;
		box-sizing: border-box;
	}

	.cart-item {
		padding: 50px;
		border-bottom: solid 1px #eee;
		align-items: center;
		position: relative;
	}

	.cart-list .cart-item:last-child {
		border-bottom: none;
	}

	.cart-checkbox {
		width: 50px;
	}

	.goods-box {
		display: contents;
	}

	.cart-item .goods-img {
		width: 100px;
		height: 100px;
		margin: 3px 30px 0 10px;
		max-height: 108px;
	}

	.cart-goods-info {
		width: calc(100% - 690px);
		height: 100%;
		line-height: 20px;
	}

	.cart-goods-name {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-all;
		/* 		padding: 5px 0; */
		font-size: 15px;
		/* height: 50px; */
		line-height: 20px;
	}

	.cart-spec-name {
		font-size: 14px;
		color: #aaa;
		width: 300px;
	}

	.cart-spec-unit {
		margin-right: 20px;
	}

	.cart-price {
		width: 200px;
		text-align: center;
		margin: 0 10px;
	}

	.cart-count-input {
		width: 200px;
		text-align: center;
		position: relative;
	}

	.cart-del-btn {
		width: 100px;
		font-size: 28px;
		text-align: center;
	}

	.cart-del-btn > i {
		cursor: pointer;
	}

	.cart-checkbox /deep/.el-checkbox__inner {
		width: 25px;
		height: 25px;
		border-radius: 20px;
	}

	.cart-checkbox /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #dcdfe6;
	}

	.cart-checkbox /deep/.el-checkbox__inner::after {
		border-width: 2px;
		height: 12px;
		left: 7px;
		top: 2px;
		width: 7px;
	}

	.cart-bottom-wrap {
		height: 70px;
		line-height: 70px;
		width: calc(100% - 50px);
		padding-left: 50px;
		font-size: 17px;
		align-items: center;
		position: absolute;
		bottom: 0;
		left: 0;
		border-top: solid 1px #eee;
	}

	.cart-all-checkbox {
		width: 70px;
	}

	.cart-all-checkbox /deep/.el-checkbox__label {
		font-size: 17px;
		color: #333 !important;
	}

	.del-all-btn {
		width: 80px;
		text-align: center;
		cursor: pointer;
		margin: 0 30px;
		position: relative;
	}

	.del-all-btn .el-icon-delete {
		margin-right: 5px;
		font-size: 25px;
		position: relative;
		top: 4px;
	}

	.sum-data {
		display: flex;
		align-items: center;
	}

	.sum-data-wrap {
		width: calc(100% - 450px);
		text-align: right;
		justify-content: flex-end;
	}

	.sum-data-money {
		margin-left: 50px;
	}

	.sum-data-money-txt {
		font-size: 20px;
		font-weight: bold;
		margin-right: 5px;
	}

	.pay-btn {
		position: absolute;
		right: 0;
		top: 0px;
		height: 70px;
		width: 200px;
		font-size: 18px !important;
	}

	.act-label {
		border-radius: 5px;
		color: #f63;
		font-size: 14px;
		border: 1px solid #f63;
		height: 20px !important;
		/* 		margin-left: 10px; */
		word-break: break-all;
		overflow: hidden;
		text-align: center;
		background: #fff;
		padding: 1px 6px;
		max-width: 240px;
		margin-right: 4px;
		margin-bottom: 6px;
	}

	.invalid-bg {
		background: #33333308 !important;
	}

	.price-detail {
		color: #aaa;
		text-decoration: line-through;
		font-size: 13px;
	}

	.warn-stock {
		color: white;
		background: black;
		opacity: 0.85;
		position: absolute;
		bottom: 4px;
		width: 100px;
		display: flex;
		justify-content: center;
		margin: 3px 30px 0 10px;
	}

	.relative-pos {
		position: relative;
	}

	.zero-stock {
		color: #ff0000;
	}

	.sold-out-img {
		width: 80px;
		height: 80px;
		position: absolute;
		top: 14px;
		right: 40px;
		z-index: 9;
	}

	.warn-blockup {
		color: red;
		font-size: 12px;
		width: 200px;
	}

	.label-content {
		display: flex;
		flex-wrap: wrap;
		margin-top: 5px;
	}

	@media screen and (max-width: 1000px) {
		.cart-wrap {
			width: calc(100vw - 80px);
			max-width: calc(100vw - 80px);
			min-width: 700px;
		}

		.cart-checkbox {
			width: 30px;
		}

		.cart-goods-info {
			width: calc(100% - 540px);
		}

		.cart-price {
			width: 150px;
		}

		.cart-count-input {
			width: 160px;
		}

		.cart-wrap .el-input-number {
			width: 140px;
		}

		.cart-del-btn {
			width: 60px;
		}

		.cart-all-checkbox {
			width: 70px;
		}
	}

	.crm-ploy-info {
		position: absolute;
		left: 0;
		bottom: 70px;
		z-index: 9;
	}

	.invalid-shopping-cart-box {
		border-top: 32px solid #f8f8f8;
	}

	.invalid-shopping-cart-title {
		display: flex;
		justify-content: space-between;
		padding: 25px 50px;
		position: sticky;
		top: 0;
		z-index: 100;
		background-color: white;
		border-bottom: solid 1px #eee;
	}

	.invalid-title-clear {
		color: #a9a9a9;
		cursor: pointer;
	}

	.cart-stock-text {
		font-size: 14px;
		color: #aaa;
		width: 100%;
		position: absolute;
		top: -30px;
	}

	.activity-label {
		background: linear-gradient(92deg, #ecd6af 0%, #f6e5c6 100%);
	}
</style>
